<template>
  <div>
    <!-- Step 1: ask whether to create journal entries -->
    <v-dialog
      v-if="step === 1"
      v-model="isDialog"
      persistent
      max-width="480"
    >
      <v-card class="treasurers-checks-je-dialog">
        <v-card-title class="je-dialog-text">
          Create Journal Entries
        </v-card-title>
        <v-card-text class="je-dialog-text">
          Do you want to create journal entry records for this treasurer's check?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="treasurerCheckJEYesBtn"
            color="primary"
            text
            @click="goToFundStep"
          >
            Yes
          </v-btn>
          <v-btn
            id="treasurerCheckJENoBtn"
            color="primary"
            text
            @click="close"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Step 2: pick the fund (defaults to 7408 Tax Refunds) -->
    <v-dialog
      v-if="step === 2"
      v-model="isDialog"
      persistent
      max-width="480"
    >
      <v-card class="treasurers-checks-je-dialog">
        <v-card-title class="je-dialog-text">
          Select Fund for Journal Entry
        </v-card-title>
        <v-card-text class="je-dialog-text">
          <v-autocomplete
            id="treasurerCheckJEFundSelect"
            v-model="selectedFund"
            :items="funds"
            item-text="fundDesc"
            item-value="_id"
            label="Fund"
            autocomplete="off"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="treasurerCheckJECreateBtn"
            color="primary"
            text
            :disabled="!selectedFund || saving"
            @click="createJE"
          >
            Create
          </v-btn>
          <v-btn
            id="treasurerCheckJECancelBtn"
            color="primary"
            text
            :disabled="saving"
            @click="close"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { toFiscalYear } from '../../../util/shared/tmc-global';

const jeFundCrudKey = 'treasurerCheckJEFunds';
const DEFAULT_FUND = '7408';

export default {
  name: 'TreasurersChecksJEDialog',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    check: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    step: 1,
    saving: false,
    fundList: [],
    selectedFund: null,
  }),
  computed: {
    isDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('dialogVal', value);
      },
    },
    funds() {
      return this.fundList.map((f) => ({
        ...f,
        fundDesc: `${f.fund} - ${f.description || ''}`,
      }));
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        // reset to the first popup each time the dialog is opened
        this.step = 1;
        this.saving = false;
        this.fundList = [];
        this.selectedFund = null;
      }
    },
  },
  methods: {
    ...mapActions('shared/fund', ['loadFunds']),
    ...mapActions('glDaily/treasurersChecks', ['createJournalEntriesForCheck']),
    async goToFundStep() {
      const fiscalYear = this.check.date ? toFiscalYear(new Date(this.check.date)) : null;
      const funds = await this.loadFunds({
        criteria: {
          fiscalYear,
          sortBy: [{ column: 'fund', direction: 'asc' }],
        },
        baseCrudKey: jeFundCrudKey,
      });
      this.fundList = funds || [];
      const defaultFund = this.fundList.find((f) => f.fund === DEFAULT_FUND);
      this.selectedFund = defaultFund ? defaultFund._id : null;
      this.step = 2;
    },
    async createJE() {
      if (!this.selectedFund) return;
      this.saving = true;
      await this.createJournalEntriesForCheck({
        check: this.check,
        fundId: this.selectedFund,
      });
      this.saving = false;
      this.close();
    },
    close() {
      this.step = 1;
      this.saving = false;
      this.isDialog = false;
    },
  },
};
</script>

<style scoped>
.treasurers-checks-je-dialog .je-dialog-text {
  color: #000 !important;
}
</style>
